import React from "react";
import { Layout, Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import Routes from "./routes";
import "./App.css";

import config, { IFMenuBase, IFMenu } from "./routes/config";
// import { path } from "ramda";
// import styled from 'styled-components'

const { Content, Header, /* Footer */ /* Sider */ } = Layout;
const { SubMenu } = Menu;

const activeAndroidMenu = [
    '/network_editor/android',
    '/sdk_editor/android',
    '/network/android',
]

const activeIosdMenu = [
    '/network_editor/ios',
    '/sdk_editor/ios',
    '/network/ios',
]


function App() {

    const location = useLocation()
    const [ current, setCurrent ] = React.useState<string>(location.pathname)

    
    React.useEffect(() => {
        let cancel = false
        if(cancel) {
            return
        }
        // console.log(1)
        if(activeAndroidMenu.find(path => location.pathname.indexOf(path) === 0)) {
            setCurrent('/sdk/android')
        }else if(activeIosdMenu.find(path => location.pathname.indexOf(path) === 0)) {
            setCurrent('/sdk/ios')
        }
        return () => {
            cancel = true
        }
    }, [])

    return (
        <Layout>
            
            {/* <Sider
                style={{
                    height: "100vh",
                    background: "#000c17",
                }}
                theme="light"
                width="140"
            >
                <div className="logo" />
                
            </Sider> */}
            <Layout
                style={{
                    height: "100vh",
                    overflowY: "auto",
                }}
            >
                <Header style={{ position: 'fixed', zIndex: 1, width: '100%', padding: '0 40px' }}>
                <Menu
                    onClick={(e: any) => setCurrent(e.key)}
                    selectedKeys={[current]}
                    theme="dark"
                    mode="horizontal"
                >
                    {config.menus.map((menu: IFMenu) => {
                        if (menu && !menu.component) {
                            return (
                                <SubMenu key={menu.key} title={menu.title}>
                                    {menu.subs?.map((subMenu: IFMenuBase) => {
                                        return (
                                            <Menu.Item key={subMenu.key}>
                                                <Link to={subMenu.key}>
                                                    {subMenu.title}
                                                </Link>
                                            </Menu.Item>
                                        );
                                    })}
                                </SubMenu>
                            );
                        }
                        return (
                            <Menu.Item key={menu.key}>
                                <Link to={menu.key}>{menu.title}</Link>
                            </Menu.Item>
                        );
                    })}
                </Menu>
                </Header>
                {/* <StyledHead 
                    className="site-layout-sub-header-background" 
                    style={{ padding: 0 }} 
                /> */}
                <Content style={{ overflowY: "auto", padding: "0 40px 0", marginTop: 64 }}>
                    {/* <Routes auth={auth} /> */}
                    <Routes auth />
                    <br />
                </Content>
                {/* <Footer className="app_layout_foot"> */}
                {/* <Copyright /> */}
                {/* </Footer> */}
            </Layout>
        </Layout>
    );
}

export default App;
